import { render, staticRenderFns } from "./statusNotification.vue?vue&type=template&id=73ddfe45&scoped=true&"
import script from "./statusNotification.vue?vue&type=script&lang=js&"
export * from "./statusNotification.vue?vue&type=script&lang=js&"
import style0 from "./statusNotification.vue?vue&type=style&index=0&id=73ddfe45&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73ddfe45",
  null
  
)

export default component.exports